import {IHttpClientResponse, TJson} from 'core/types';

export abstract class AbstractApiResponseInterceptor<RequestOptions = unknown> {
    public abstract intercept(
        response: IHttpClientResponse<TJson, Headers, Response>,
        requestOption?: RequestOptions
    ): Promise<typeof response>;
}
